/* ===========================================================
   OFFLINE PAGE
   =========================================================== */
import React from "react";
import { Icons } from "@/lib/icons";

const { useState: ofUS, useEffect: ofUE } = React;

function OfflinePage() {
  const [online, setOnline] = ofUS(typeof navigator !== "undefined" ? navigator.onLine : true);
  ofUE(() => {
    const u = () => setOnline(navigator.onLine);
    window.addEventListener("online", u);
    window.addEventListener("offline", u);
    return () => { window.removeEventListener("online", u); window.removeEventListener("offline", u); };
  }, []);

  const cached = [
    { label: "Home", href: "/" },
    { label: "Categories", href: "/pages/storefront/categories.html" },
    { label: "Cart", href: "/pages/storefront/cart.html" },
    { label: "Track an order", href: "/pages/storefront/track-order.html" },
    { label: "Privacy policy", href: "/pages/policy/privacy.html" },
  ];

  return (
    <div className="container offline-page">
      <div className="offline-status">
        <span style={{ width: 8, height: 8, borderRadius: 999, background: online ? "var(--emerald)" : "var(--rose)", boxShadow: online ? "0 0 0 4px rgba(79, 107, 42, 0.25)" : "0 0 0 4px rgba(185, 72, 36, 0.25)" }} />
        <span className="mono" style={{ fontSize: 11, letterSpacing: "0.08em", textTransform: "uppercase", color: "var(--ink-3)" }}>
          {online ? "Connection restored" : "You're offline"}
        </span>
      </div>

      <div className="offline-art">
        <span className="offline-art-wave" />
        <Icons.Snowflake size={56} stroke={1.4} />
      </div>

      <h1 className="offline-title">{online ? "You're back online." : "We can't reach our servers."}</h1>
      <p className="offline-desc">
        {online
          ? "Connection is good. Refresh the page or jump back to where you were heading."
          : "Some parts of the app may still work from your last visit. Once you're back online, your cart, recent orders and track-order links will sync automatically."}
      </p>

      <div style={{ display: "flex", gap: 10, marginTop: 20, flexWrap: "wrap", justifyContent: "center" }}>
        <button className="btn btn-primary" onClick={() => window.location.reload()}>
          <Icons.ArrowR size={14} stroke={2} style={{ transform: "rotate(180deg)" }} /> Try again
        </button>
        <a href="/" className="btn btn-outline">Go to homepage</a>
      </div>

      <div className="offline-cached">
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div className="kicker">Cached pages</div>
          <span style={{ width: 1, height: 12, background: "var(--line)" }} />
          <span className="mono" style={{ fontSize: 11, color: "var(--ink-3)" }}>{cached.length} available offline</span>
        </div>
        <div className="offline-cached-list">
          {cached.map((c) => (
            <a key={c.href} href={c.href}>
              <span>{c.label}</span>
              <Icons.ArrowR size={13} stroke={1.7} />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export { OfflinePage };
